import React, { useEffect, useState } from "react";
import icnLogout from "../../images/icons/Logout_dark_grey48.svg";
import icnLogoutActive from "../../images/icons/Logout_red48.svg";
import icnAlarm from "../../images/icons/ring_darkgrey48.png";
import iconAlarmActive from "../../images/icons/ring_red48.svg";
import iconProfile from "../../images/icons/personal_account_dark_grey48.png";
import iconProfileActive from "../../images/icons/personal_account_red48.svg";
import logo from "../../images/icons/logo.png";
import { Link, NavLink, useLocation, useNavigate } from "react-router";
import { observer } from "mobx-react-lite";
import keyboardState from "../../service/state/keyboard.state";
import { Confirm } from "../../UI/components/Confirm";
//icons-profile2.png

export const Header = observer(() => {
  const [iconAlarm, setIconAlarm] = useState(icnAlarm);
  const [iconDevice, setIconDevice] = useState(null);
  const [iconMyProfile, setIconMyProfile] = useState(iconProfile);
  const [iconLogout, setIconLogout] = useState(icnLogout);
  const [confirmLogout, setConfirmLogout] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const logOut = async () => {
    navigate("/login");
  };

  const selectIconFile = (e, func) => {
    console.log(e.target.files[0]);
    const imageUrl = URL.createObjectURL(e.target.files[0]);
    func(imageUrl);
    keyboardState.setParameters("press_key", "");
  };

  return (
    <div className="header_container">
      {confirmLogout ? (
        <Confirm
          title="Вы действительно хотите выйти из системы?"
          no={() => setConfirmLogout(false)}
          yes={logOut}
          ok="Выйти"
          cancel="Отмена"
        />
      ) : (
        <></>
      )}
      <div className="header_container_content">
        <Link to={"/home"} className="logog_container">
          <img src={logo} alt="logo" className="logo" />
        </Link>
        <div className="nav_container">
          <div className="header_container_pages">
            <div className="res">
              {location.pathname !== "/alert" ? (
                <NavLink
                  onMouseMove={() => setIconAlarm(iconAlarmActive)}
                  onMouseOut={() => setIconAlarm(icnAlarm)}
                  className="icon_myprofile_container"
                  to={"/alert"}
                >
                  <img className="icon_alarm" src={iconAlarm} />
                </NavLink>
              ) : (
                <NavLink className="icon_myprofile_container" to={"/alert"}>
                  <img className="icon_alarm" src={iconAlarmActive} />
                </NavLink>
              )}
              {keyboardState.press_key === "Control" ? (
                <input
                  type="file"
                  className="inpt_select_icon_header"
                  onChange={(e) => selectIconFile(e, setIconAlarm)}
                />
              ) : (
                <></>
              )}
            </div>

            <div className="res">
              {keyboardState.press_key === "Control" ? (
                <input
                  type="file"
                  className="inpt_select_icon_header"
                  onChange={(e) => selectIconFile(e, setIconDevice)}
                />
              ) : (
                <></>
              )}
              <NavLink
                className="nav_link title_header_btn icon_myprofile_container"
                to={"/home"}
              >
                {iconDevice === null ? (
                  <span>Устройства</span>
                ) : (
                  <img className="icon_alarm" src={iconDevice} />
                )}
              </NavLink>
            </div>
            <div className="rel">
              {keyboardState.press_key === "Control" ? (
                <input
                  type="file"
                  className="inpt_select_icon_header"
                  onChange={(e) => selectIconFile(e, setIconMyProfile)}
                />
              ) : (
                <></>
              )}
              {location.pathname !== "/myprofile" ? (
                <NavLink
                  onMouseMove={() => setIconMyProfile(iconProfileActive)}
                  onMouseOut={() => setIconMyProfile(iconProfile)}
                  className="icon_myprofile_container"
                  to={"/myprofile"}
                >
                  <img className="icon_myprofile" src={iconMyProfile} />
                </NavLink>
              ) : (
                <NavLink className="icon_myprofile_container" to={"/myprofile"}>
                  <img className="icon_myprofile" src={iconProfileActive} />
                </NavLink>
              )}
            </div>
          </div>
          <div className="nav_link_off rel">
            {keyboardState.press_key === "Control" ? (
              <input
                type="file"
                className="inpt_select_icon_header"
                onChange={(e) => selectIconFile(e, setIconLogout)}
              />
            ) : (
              <></>
            )}
            <img
              className="icon_logout"
              src={iconLogout}
              onMouseMove={() => setIconLogout(icnLogoutActive)}
              onMouseOut={() => setIconLogout(icnLogout)}
              onClick={() => setConfirmLogout(true)}
            />
          </div>
        </div>
      </div>
    </div>
  );
});
